import { put, takeLatest, takeEvery, all, select, take, call } from 'redux-saga/effects';
import axios from 'axios';
import { saveAs } from 'file-saver';
import getConfig from 'next/config';
import { getKeycloakInstance } from '@react-keycloak-fork/ssr';
import * as newayApi from '../../api/neway';
import * as calculationTypes from '../constants/calculations';
import {
    FILES_FETCH_REQUEST,
    FILES_FETCH_SUCCESS,
    FILES_FETCH_FAIL,
    FILE_FETCH_REQUEST,
    FILE_FETCH_SUCCESS,
    FILE_FETCH_FAIL,
    FILE_KREDITDATA_SAVE_REQUEST,
    FILE_UPLOAD_SUCCESS,
    FILE_UPLOAD_FAIL,
    FILE_DOWNLOAD_REQUEST,
    FILE_DOWNLOAD_SUCCESS,
} from '../constants/file';
// import uploadTypes from '../constants/uploadTypes'

const { publicRuntimeConfig } = getConfig();
const config = publicRuntimeConfig;
function* fetchFiles() {
    try {
        const { token } = getKeycloakInstance();
        const { data } = yield axios({
            method: 'GET',
            url: `${config.apiUrl}/user/files`,
            headers: { Authorization: `Bearer ${token}` },
        });

        const { files } = data;
        const payload = { documents: files };

        yield put({ type: FILES_FETCH_SUCCESS, payload });
        if (files.length && files.some(x => !!x.content && !!x.content.profil)) {
            yield put({
                type: calculationTypes.PENSION_ANALYSIS_CALCULATION_REQUEST,
            });
        }

        // recrape neway.dk profiles with legacy scrape format
        // if (files.every(x => x.content?.pensionData && !x.content?.profil)) {
        //     yield all(files.filter(file => file.fileType === 'PensionsInfoFile').map(file => call(requestPi, file)));
        // }
    } catch (error) {
        console.error(error);
        yield put({ type: FILES_FETCH_FAIL, payload: error });
    }
}

function* fetchFile({ payload }) {
    try {
        const { token } = getKeycloakInstance();
        const { data } = yield axios({
            method: 'GET',
            url: `${config.apiUrl}/user/files/${payload.fileId}`,
            headers: { Authorization: `Bearer ${token}` },
        });

        const { file } = data;

        yield put({ type: FILE_FETCH_SUCCESS, payload: file });
    } catch (error) {
        console.error(error);
        yield put({ type: FILE_FETCH_FAIL, payload: error });
    }
}


function* saveKreditdataPdf({ payload: { id, content, fileType } }) {
    try {
        if(fileType === 'PensionsInfoFile'){
            const file = yield call(newayApi.saveKreditdataPensionPdf, { id });
            yield call(newayApi.updateContent, { fileId: file.fileId, content });
            yield put({ type: 'KREDIT_DATA_PENSION_PDF_SAVE_SUCCESS', payload: file });
            yield put({ type: FILE_UPLOAD_SUCCESS, payload: { file:{ ...file, content, message: 'Dine pensionsoplysninger er modtaget.'  } } });
            yield put({ type: 'FILES_FETCH_REQUEST' });
        } else if(fileType === 'BudgetFile'){
            const file = yield call(newayApi.saveKreditdataBudgetPdf, { id });
            yield put({ type: FILE_UPLOAD_SUCCESS, payload: { file:{ ...file, content, message: 'Dit budget er modtaget.' } } });
        } else {
            yield put({ type: FILE_UPLOAD_FAIL, payload: 'No Uniify Files fetched' });
        }
    } catch (error) {
        console.error(error);
        yield put({ type: FILE_UPLOAD_FAIL, payload: error });
    }
}
function* downloadDocumentSaga({ payload }) {
    const { token } = getKeycloakInstance();
    const res = yield axios({
        method: 'GET',
        url: `${config.apiUrl}/user/files/${payload.fileId}/file`,
        responseType: 'blob',
        headers: { Authorization: `Bearer ${token}` },
    });
    saveAs(res.data, payload.fileName);
    yield put({
        type: FILE_DOWNLOAD_SUCCESS,
    });
}

function* firstFetch() {
    yield take('AUTH_RPT_AVAILABLE');
    yield put({ type: 'FILES_FETCH_REQUEST' });
}

export default function* documentUploadSaga() {
    yield all([
        firstFetch(),
        takeLatest(FILE_DOWNLOAD_REQUEST, downloadDocumentSaga),
        takeLatest(FILES_FETCH_REQUEST, fetchFiles),
        takeLatest(FILE_KREDITDATA_SAVE_REQUEST, saveKreditdataPdf),
        takeEvery(FILE_FETCH_REQUEST, fetchFile),
    ]);
}

function urltoFile(base64data, mimeType) {
    const bs = atob(base64data);
    const buffer = new ArrayBuffer(bs.length);
    const ba = new Uint8Array(buffer);
    for (let i = 0; i < bs.length; i++) {
        ba[i] = bs.charCodeAt(i);
    }
    const file = new Blob([ba], { type: mimeType });
    return file;
}
